import { titleCase } from "@multicines/utils";
import React from "react";

import Styles from "./MovieInformation.styles";
import { MovieInformationProps as Props } from "./MovieInformation.types";
import useI18n from "hooks/useI18n";

const MovieInformation: React.FC<Props> = props => {
  const { synopsis, actors, ageRestriction, genre } = props;
  const { age } = ageRestriction ?? {};
  const t = useI18n().movie;

  const renderInformation = () => {
    if (!age) return;

    if (age === 0) {
      return t.allPublic;
    }

    if (age < 0) {
      return `-${age} ${t.withSupervision}`;
    }

    if (age === 12) {
      return `${age} ${t.age}`;
    }

    return `+${age} ${t.age}`;
  };

  return (
    <Styles className="MovieInformation">
      <div className="MovieInformation__section">
        <p className="MovieInformation__title">{t.synopsis}</p>
        <p className="MovieInformation__detail">
          {synopsis ? synopsis : t.noSynopsis}
        </p>
      </div>
      <div className="MovieInformation__section">
        <p className="MovieInformation__title">{t.information}</p>
        <div className="MovieInformation__row">
          <div className="MovieInformation__chip">
            <p className="MovieInformation__chip__text">
              {titleCase(genre ?? "")}
            </p>
          </div>
          <div className="MovieInformation__chip">
            <p className="MovieInformation__chip__text">
              {renderInformation()}
            </p>
          </div>
        </div>
      </div>
      {actors ? (
        <div className="MovieInformation__section">
          <p className="MovieInformation__title">{t.actors}</p>
          <p className="MovieInformation__actor__name">{actors}</p>
          {/* TODO: add when actors image is available <div className="MovieInformation__row">
          {actorsData?.map((item, index) => {
            if (index >= 8 && !seeAll) {
              return null;
            }
            return (
              <div key={index} className="MovieInformation__actor">
                <div className="MovieInformation__circle">
                  <div
                    className="MovieInformation__box"
                    data-letters={item[index]}
                  />
                </div>
                <p className="MovieInformation__actor__name">{item}</p>
              </div>
            );
          })}
        </div> */}
          {/* <p
          className="MovieInformation__see-all"
          onClick={() => setSeeAll(!seeAll)}
        >
          {!seeAll ? t.seeAll : t.seeLess}
        </p> */}
        </div>
      ) : null}
    </Styles>
  );
};

export default MovieInformation;
